import { AllocCropNCtrl } from "./alloc/allocCropN"
import { AllocSMNCtrl } from "./alloc/allocSMN"
import { HsaAllocPopupCtrl } from "./dashboard/alloc/hsa/alloc-popup"
import { PcnAnalysisAllocPopupCtrl } from "./dashboard/alloc/pcn/alloc-popup"
import { SoilAnalysisAllocPopupCtrl } from "./dashboard/alloc/soilanalysis/alloc-popup"
import { SoilColumnsEditCtrl } from "./dashboard/columns-popup"
import { DashboardCtrl } from "./dashboard/dashboard"
import { MapAllocationsCtrl } from "./dashboard/global-map/allocation/map-allocation"
import { GlobalMapPopupCtrl } from "./dashboard/global-map/global-map-popup"
import { MapCtrl } from "./dashboard/global-map/map/map"
import { HealthySoilsAssessmentTableCtrl } from "./dashboard/hsa/hsa"
import { MapViewerCtrl } from "./dashboard/map/viewer"
import { NitrogenAnalysisTableCtrl } from "./dashboard/nitrogen/nitrogen"
import { PcnAnalysisTableCtrl } from "./dashboard/pcn/pcn"
import { SsmAnalysisTableCtrl } from "./dashboard/ssm/ssm"
import { HsaEditPopupCtrl } from "./edit/hsa/edit"
import { createLocationPopup } from "./edit/hsa/location-popup"
import { NitrogenAnalysisEditCtrl } from "./edit/nitrogen/nitrogen"
import { PcnAnalysisEditCtrl } from "./edit/pcn/pcn"
import { SoilAnalysisEditCtrl } from "./edit/soil/soil"
import { SsmAttributeCtrl } from "./edit/ssm/attr"
import { SsmAnalysisEditCtrl } from "./edit/ssm/ssm"
import { GeneratePopupCtrl } from "./generate/generatePopup"
import { SoilAnalysisLayer } from "./map/soilAnalysisLayer"
import { TextureLayer } from "./map/textureLayer"
import { loadSoilTextureLayers } from "./map/textureLayerLoader"
import { getSoilMapViewers } from "./map/viewer/viewers"
import { ZoneEditCtrl } from "./map/zoneEdit"
import { DatalayerFactoryProvider, datalayers, DatalayersApiLoaderProvider, DatalayerViewManagerProvider, ISoilUnitConfig, SoilUnit } from "./omnia"
import { AnalysisOrderPopupCtrl } from "./order/orderPopup"
import { PlanNgWrapper } from "./plan/components/ngcontroller"
import { SoilService } from "./services/service"
import { SoilTypeService } from "./services/soilTypeService"
import { SoilUnitService } from "./services/soilUnitService"
import { SoilCtrl } from "./soil"
import { ColumnsPopupCtrl } from "./table/columnsPopup"
import { SoilAnalysisTableCtrl } from "./table/table"
import { LayerTypeId } from "./types"

import { DashbordSoilAnalysisTableCtrl } from "./dashboard/soil/soil"

export function setup(module: ng.IModule) {

    let units: ISoilUnitConfig = {
        soil: SoilUnit.Ppm,
        nitrogen: SoilUnit.KgHa
    }

    module

        .constant("omniaSoilUnitConfig", units)

        .service("OmniaSoilService", SoilService)
        .service("OmniaSoilTypeService", SoilTypeService)
        .service("OmniaSoilUnitService", SoilUnitService)

        .directive("omniaSoil", SoilCtrl.create)

        .directive("omniaSoilAnalysisTable", SoilAnalysisTableCtrl.create)
        .directive("omniaSoilColumnsPopup", ColumnsPopupCtrl.create)

        .directive("omniaSoilGeneratePopup", GeneratePopupCtrl.create)

        .directive("omniaSoilOrderPopup", AnalysisOrderPopupCtrl.create)

        .directive("omniaSoilAllocNitrogenCropN", AllocCropNCtrl.create)
        .directive("omniaSoilAllocNitrogenSmn", AllocSMNCtrl.create)

        .directive("omniaSoilEditorSoilPopup", SoilAnalysisEditCtrl.createPopup)
        .directive("omniaSoilEditorNitrogenPopup", NitrogenAnalysisEditCtrl.createPopup)
        .directive("omniaSoilEditorPcnPopup", PcnAnalysisEditCtrl.createPopup)
        .directive("omniaSoilEditorSsmPopup", SsmAnalysisEditCtrl.createPopup)
        .directive("omniaSoilEditorSsmAttr", SsmAttributeCtrl.create)

        .directive("omniaSoilMapZoneEdit", ZoneEditCtrl.create)

        .directive("omniaSoilDashboard", DashboardCtrl.create)
        .directive("omniaSoilDashboardSoilAnalysis", DashbordSoilAnalysisTableCtrl.create)
        .directive("omniaSoilDashboardSsmAnalysis", SsmAnalysisTableCtrl.create)
        .directive("omniaSoilDashboardHsa", HealthySoilsAssessmentTableCtrl.create)
        .directive("omniaSoilDashboardNitrogenAnalysis", NitrogenAnalysisTableCtrl.create)
        .directive("omniaSoilDashboardPcnAnalysis", PcnAnalysisTableCtrl.create)

        .directive("omniaSoilDashboardColumnsPopup", SoilColumnsEditCtrl.createPopup)

        .directive("omniaSoilMapViewer", MapViewerCtrl.create)

        .directive("omniaSoilAssessmentEditPopup", HsaEditPopupCtrl.create)
        .directive("omniaSoilAssessmentAllocPopup", HsaAllocPopupCtrl.create)
        .directive("omniaSoilAssessmentLocationPopup", createLocationPopup)

        .directive("omniaSoilSoilanalysisAllocPopup", SoilAnalysisAllocPopupCtrl.create)
        .directive("omniaSoilPcnAllocPopup", PcnAnalysisAllocPopupCtrl.create)

        .directive("omniaSoilGlobalMapPopup", GlobalMapPopupCtrl.create)
        .directive("omniaSoilGlobalMapAllocation", MapAllocationsCtrl.create)
        .directive("omniaSoilGlobalMapMap", MapCtrl.create)

        .directive("omniaSoilPlan", PlanNgWrapper.create)

        ;

    module.config(["OmniaDatalayersViewManagerProvider", (provider: DatalayerViewManagerProvider) => {

        const viewers = getSoilMapViewers(units)

        provider.register(viewers)


    }]);

    module.config(["OmniaDatalayersApiLoaderProvider", (provider: DatalayersApiLoaderProvider) => {

        provider.addLoader(loadSoilTextureLayers)

    }]);

    module.config(["OmniaDatalayersFactoryProvider", (provider: DatalayerFactoryProvider) => {

        provider.register(LayerTypeId.SoilType, (layer, ctxt) => new TextureLayer(layer, ctxt));
        provider.register(LayerTypeId.SoilAnalysis, (layer, ctxt) => new SoilAnalysisLayer(layer, ctxt));
        provider.register(LayerTypeId.PcnAnalysis, (layer, ctxt) => new SoilAnalysisLayer(layer, ctxt));

    }]);


}
